export default "__VITE_ASSET__tHUQ9TUi__"